<template>
  <div class="row">
    <div class="row-header">
        <div class="product-image">
            <router-link tag="a" :to="{name: 'play', params: {slug: item.slug}}">
                <img class="row-image" :src="'/images/plays/' + item.mainimage" :alt="item.title">
            </router-link>
        </div>
        <div class="product-info block-with-vsmall-vertical-gap">
            <router-link tag="a" :to="{name: 'play', params: {slug: item.slug}}">
                <h5 class="title is-4">{{ item.title }}</h5>
            </router-link>
            <p class="subtitle is-6">{{ prettifydate(item.dates.startdate) }}</p>
            <div>
              <p v-if="item.blurbExcerpt" v-html="item.blurbExcerpt" />
              <p v-else v-html="truncatedBlurb(item.blurb)" />
            </div>
        </div>
    </div>
    
    <!-- <router-link tag="a" class="button" :to="{ name: 'product', params: { slug: item.slug }}">Description</router-link>
    <button class="button is-primary" @click="addToCart(item)">Buy Now</button> -->
  </div>
</template>

<script>
var moment = require('moment');
//import mixins from '@/mixins/mixins';
// import Api from '@/config/Api'; // MCH added

// import AlertMeButton from './AlertMeButton';
// import MaxPriceWidget from './MaxPriceWidget';

export default {
    props: ['item'],
    methods: {
        prettifydate(date) {
            return moment(date).format("dddd, Do MMMM YYYY");
        },
        truncatedBlurb(blurb) {
            var output = this.$options.filters.truncate(blurb, 350)
            // | truncate(160, '...')
            return output;
        }
    }
    /* components: {
        ProductShopRows,
        ProductEventRows,
        AlertMeButton,
        MaxPriceWidget
    }, */
    //mixins: [mixins],
   
    /*MCH START*/
    /* data() {
        return {
            rrpPrice: '8',
            // pricey: '',
        }
    }, */
    /*created() {
        Api().get('/productGroups')
            .then(response => {
                // this.productGroups = response.data.productGroups;

                console.log("AA:",this.productGroup.rrpPrice); 
                //this.$set(this.productGroup, 'rrpPrice', 0);
                //console.log("BB:",this.productGroup.rrpPrice); 
            });
    }*/
    /*MCH END*/


}
</script>

<style scoped>

/* img.row-image {
  width: 62px;
  height: 62px;
} */
.product-image {
  vertical-align: top;
  display: inline-block;
}
/* .product-info {
  display: inline-block;
} */
</style>



// WEBPACK FOOTER //
// src/components/cards/PreviousproductionRow.vue